var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Header',{attrs:{"active":6}}),_c('Screen1'),_c('Screen2'),_c('Screen3'),_c('div',{staticClass:"join-link flex-center"},[_c('router-link',{attrs:{"to":"/join"}},[_c('p',{staticClass:"join-title"},[_vm._v("加入我们")])])],1),_c('Position'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }